import {RuleEditorConditionsGroup} from '../../rules/ruleConditionModel';

export const previewerEditorConditionGroups: ReadonlyArray<RuleEditorConditionsGroup> = [];
